/*global AmCharts, App */

Components.Energy.Manager.DonutChart = function(container, rawData) {
    this.chart;
    this.dataProvider = [];
    this.colors = App.Ui.getColors();
    this.prepareDataForChart = function () {
        this.dataProvider = [];
        for (var i in rawData) {
            var record = rawData[i];
            if (typeof record === "undefined") continue;
            record.color = this.colors[i % this.colors.length];
            this.dataProvider.push(record);
        }
    };
    this.createChart = function () {
        var _chart = new AmCharts.AmPieChart();
        _chart.theme = "destiny";
        _chart.dataProvider = this.dataProvider;
        _chart.titleField = "title";
        _chart.valueField = "value";
        _chart.colorField = "color";
        _chart.labelsEnabled = true;
        _chart.labelRadius = -30;
        _chart.labelText = "[[percents]]%";
        _chart.color = "#fff";
        _chart.radius = "50%";
        _chart.innerRadius = "50%";
        _chart.pullOutRadius = 0;
        _chart.sequencedAnimation = false;
        _chart.startDuration = 0;
        _chart.write(container);
        this.chart = _chart;
    };
    this.init = function () {
        this.prepareDataForChart();
        this.createChart();
    };
};
